// 🔴🔴 N°728-2 — LE REGISTRE DES CAPACITÉS DU MENU LATÉRAL.
//
// ⚠️ MESURÉ : le filtre des entrées de menu (`OmniHub.jsx`) ⛔ ne connaissait
// QU'UNE capacité, écrite en dur dans un `if` :
//     if (item.capability === "devis_catalogue" && !hasDevisCatalogue() …)
// Toute entrée déclarant une AUTRE capacité passait donc le filtre SANS ÊTRE
// ÉVALUÉE — un gate silencieusement inopérant, la pire forme : on croit la
// porte fermée.
//
// 🔑 Une capacité de plus = UNE LIGNE ICI, ⛔ aucune branche de plus dans le
// filtre. Un nom ABSENT du registre MASQUE l'entrée (défaut sûr, DEC-079 :
// « unknown ≠ enabled ») — une capacité mal orthographiée ⛔ ne doit pas ouvrir
// la porte en silence.
//
// ⚠️ CE FICHIER EXISTE SÉPARÉMENT POUR POUVOIR ÊTRE MESURÉ : importer
// `OmniHub.jsx` dans un banc monte l'application entière (routeur, éditeurs
// riches en ESM non transformé…) et échoue. Un registre de règles ⛔ n'a rien à
// faire au milieu d'un écran de 3 000 lignes.
import { hasDevisCatalogue, hasDevisInstallateur,
         hasDossierAmo, hasVisitesTerrain, hasAidesMpr } from "./tenantProfile";

export const CAPACITES_MENU = {
  devis_catalogue: hasDevisCatalogue,
  devis_installateur: hasDevisInstallateur,
  dossier_amo: hasDossierAmo,
  visites_terrain: hasVisitesTerrain,
  aides_mpr: hasAidesMpr,          // T-482 : « Suivi MaPrimeRénov' »
};

/**
 * Le tenant courant a-t-il la capacité que cette entrée de menu exige ?
 * ⛔ Aucune capacité déclarée ⇒ entrée universelle (rétro-compatibilité).
 * ⛔ Capacité inconnue du registre ⇒ entrée MASQUÉE.
 */
export function aLaCapaciteDuMenu(item) {
  if (!item || !item.capability) return true;
  // 🔴 N°811 — une LISTE = « l'une OU l'autre » (ex. Visiteurs : AMO ou
  // visites terrain). Chaque nom reste soumis au registre : inconnu ⇒ faux.
  const noms = Array.isArray(item.capability) ? item.capability : [item.capability];
  return noms.some((nom) => {
    const teste = CAPACITES_MENU[nom];
    return !!teste && teste();
  });
}
